/**
 * State used for the zip code lookup.
 * @param AddressLookupService service used for the address lookup.
 * @param zipDto view model of the zip code.
 * @param onLookup callback with type Address => Unit invoked after initial zip code processing.
 * @param onLookupFail callback with type String => Unit invoked when lookup failed due to network error.
 */
define([], () => (AddressLookupService, {zipDto, onLookup}) => {
    let loadError = false;

    return {
        zip: {
            get value() {
                return zipDto.value;
            },
            set value(nv) {
                zipDto.value = nv;
                loadError = false;
            },
            aspects: zipDto.aspects
        },
        get hasError() {
            return loadError;
        },
        lookup: onLookup
    };
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/quickquote/pa/tiles/address/models/ZipLookupState.js
 **/